<template>
  <div>
    <template v-for="value in orders" >
      <div class="barcodeprint pagebarcode" :key="value.barcode">
        <table>
          <tr style="height:100px;">
            <td style="padding-left:20px;font-size:90px;">{{value.indicator}}</td>
            <td style="padding-left:30px; padding-top:30px;">
              
              <barcode
                v-bind:value="value.barcode"
                format="CODE128"
                width="2"
              >Barkod basılamadı tekrar deneyiniz.</barcode>
            </td>
          </tr>
        </table>
        <table id="v-for-object">
          <!-- <tr style="height:12px;"></tr> -->
          <tr>
            <td style="font-size:18px;     height: 28px;">Adrese Teslimatlı Gönderim</td>
            <td style="font-size:18px; padding-left: 50px">   <b>{{getCargoName(value.barcode)}} </b></td>
          </tr>
          <tr>
            <td class="baslik">Kargo Bilgileri</td>
            <!-- <td style="font-weight:bold">Sigortalı Gönderim</td> -->
          </tr>
          <tr>
            <td class="baslik">Sipariş No:</td>
            <td>
              <template v-for="item in uniqueOrderNumber(value.items)">{{item}},</template>
            </td>
          </tr>
          <tr>
            <td class="baslik">Ad-Soyad:</td>
            <td style="font-weight:bold">{{value.recipientName}}</td>
          </tr>
          <tr>
            <td class="baslik">Fatura Ad-Soyad:</td>
            <td>{{value.companyName}}</td>
          </tr>
          <tr style="    height: 40px;">
            <td class="baslik">Teslimat Adresi:</td>
            <td>{{value.shippingAddressDetail}}</td>
          </tr>
          <tr>
            <td class="baslik">Semt:</td>
            <td>{{value.shippingDistrict}}</td>
          </tr>
          <tr>
            <td class="baslik">Şehir:</td>
            <td>{{value.shippingCity}}</td>
          </tr>
          <tr>
            <td class="baslik">Tel:</td>
            <td>{{value.phoneNumber}}</td>
          </tr>

          <tr>
            <td class="baslik">Sipariş Tarih/Saat:</td>
            <td>{{value.orderDate | formatDate}}</td>
          </tr>
          <tr>
            <td class="baslik">Barkod</td>
            <td>{{value.barcode}}</td>
          </tr>

        </table>
      </div>
    </template>
  </div>
</template>
<style>
.barcodeprint td:first-child {
  padding-right: 23px;
}
.barcodeprint .baslik {
  /* border: 1px black solid; */

  width: 161px !important;
}
.barcodeprint td {
  /* border: 1px black solid; */

  width: 500px;
}
.barcodeprint table {
  width: 595px !important;
}
.barcodeprint td:nth-child(1) {
  font-weight: bold;
  text-align: center;
}
.application {
  background: #ffffff !important;
}
body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
}
* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}
.pagebarcode {
  width: 23cm;
  /* min-height: 15.7cm; */
  padding: 0;
  padding-top: 30px;
  padding-right: 50px;
  padding-left: 100px;
  margin: 1cm auto;
  /* border: 1px red solid; */
  /* border-radius: 5px; */
  background: white;
  font: 11pt "Tahoma";
}

@page {
  margin: 0;
}
@media print {
    html,body {
                width: initial !important;
                height: initial !important;
            }
}

@media print {
  .pagebarcode {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    /* max-height: 15.7cm; */
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }
}
</style>
<script>
import VueBarcode from "vue-barcode";

export default {
  data: () => ({
    orders: [],
    barcodeValue: "6219109850391"
  }),

  components: {
    barcode: VueBarcode
  },

  methods: {
    uniqueOrderNumber(item) {
      return [...new Set(item.map(p => p.orderNumber))];
    },
    getCargoName(item) {
      if (item.startsWith('627'))return "HepsiJet";
      if (item.startsWith('625'))return "Mng";
    }
  },
  mounted() {
    this.$store.commit("SET_LAYOUT", "empty-layout");
    // orders=this.$store.state.orders.selectedOrders;
    this.orders = JSON.parse(sessionStorage.getItem("barcodeprint")).sort(
      function(a, b) {
        return a.indicator > b.indicator ? 1 : -1;
      }
    );
     window.print();
  }
};
</script>
